import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-people-of-interest.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-people-of-interest.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../shared/application-view.service";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../app-controller.service";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { AlertType } from "../../shared/models/alert";
import { ViewApplicationPeopleOfInterestConstants } from "./view-application-people-of-interest.constants";
let ViewApplicationPeopleOfInterestComponent = class ViewApplicationPeopleOfInterestComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    changeDetectorRef;
    routerParamsService;
    peopleOfInterestForm;
    transferorFormControlName = ViewApplicationPeopleOfInterestConstants.TRANSFEROR_FORM_CONTROL_NAME;
    transfereeFormControlName = ViewApplicationPeopleOfInterestConstants.TRANSFEREE_FORM_CONTROL_NAME;
    conveyancerFormControlName = ViewApplicationPeopleOfInterestConstants.CONVEYANCER_FORM_CONTROL_NAME;
    transferorDisableFilterBy = true;
    transferorDisableEditing = false;
    transferorShowFields = true;
    transferorGroups = [];
    transferorLabel = ViewApplicationPeopleOfInterestConstants.TRANSFEROR_LABEL;
    transfereeDisableFilterBy = true;
    transfereeDisableEditing = false;
    transfereeShowFields = true;
    transfereeGroups = [];
    transfereeLabel = ViewApplicationPeopleOfInterestConstants.TRANSFEREE_LABEL;
    copyApplicantToTransfereeLabel = ViewApplicationPeopleOfInterestConstants.COPY_APPLICANT_TO_TRANSFEREE_LABEL;
    conveyancerDisableFilterBy = true;
    conveyancerDisableEditing = false;
    conveyancerShowFields = true;
    conveyancerGroups = [];
    conveyancerLabel = ViewApplicationPeopleOfInterestConstants.CONVEYANCER_LABEL;
    copyApplicantToTransfereeFormControlName = ViewApplicationPeopleOfInterestConstants.COPY_APPLICANT_TO_TRANSFEREE_FORM_CONTROL_NAME;
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.populatePeopleOfInterestForms();
    }
    loadMetadata(stepMeta) {
        try {
            this.transferorGroups = stepMeta.transferorGroup;
            this.transfereeGroups = stepMeta.transfereeGroup;
            this.conveyancerGroups = stepMeta.conveyancerGroup;
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.peopleOfInterestForm = this.aflaModuleStrategyService.form.get("peopleOfInterestForm");
    }
    onBtnCopyApplicantToTransfereeClicked(event) {
        const transfereeFormControl = this.peopleOfInterestForm.get("transferee");
        if (event.currentTarget.checked === true) {
            transfereeFormControl.disable();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(true);
            this.changeDetectorRefs.detectChanges();
        }
        else {
            transfereeFormControl.enable();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(true);
            this.changeDetectorRefs.detectChanges();
        }
    }
    handleRouteChange() {
    }
    populatePeopleOfInterestForms() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.transferor !== undefined && application.transferor !== null && application.transferor.length > 0) {
                    const transferor = application.transferor[0];
                    this.peopleOfInterestForm.get(this.transferorFormControlName).setValue(transferor);
                }
                this.peopleOfInterestForm.get(this.transferorFormControlName).disable();
                if (application && application.transferee !== undefined && application.transferee !== null && application.transferee.length > 0) {
                    const transferee = application.transferee[0];
                    this.peopleOfInterestForm.get(this.transfereeFormControlName).setValue(transferee);
                }
                this.peopleOfInterestForm.get(this.transfereeFormControlName).disable();
                if (application && application.conveyancer !== undefined && application.conveyancer !== null && application.conveyancer.length > 0) {
                    const conveyancer = application.conveyancer[0];
                    this.peopleOfInterestForm.get(this.conveyancerFormControlName).setValue(conveyancer);
                }
                this.peopleOfInterestForm.get(this.conveyancerFormControlName).disable();
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationPeopleOfInterestComponent = __decorate([
    Component({
        selector: "app-view-application-people-of-interest",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationPeopleOfInterestComponent);
export { ViewApplicationPeopleOfInterestComponent };
